import { NoDistrictRouteGuard } from '../../guards/no-district-route-guard/no-district-route-guard';
import { SessionStorageEntityIdResolver } from '../../resolvers/session-storage-entityid/session-storage-entityid.resolver';

export const shelterPickerRoute = {
  path: 'shelter-picker',
  url: '/shelter-picker',
  canActivate: [NoDistrictRouteGuard],
  resolve: {
    entityId: SessionStorageEntityIdResolver,
  },
  loadChildren: () => import('../../../shell/shelter-picker/shelter-picker.module').then(m => m.ShelterPickerModule),
};
